/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1SsoimageIdStatusMutationRequest,
  PatchApiV1SsoimageIdStatusMutationResponse,
  PatchApiV1SsoimageIdStatusPathParams,
  PatchApiV1SsoimageIdStatus400,
  PatchApiV1SsoimageIdStatus401,
  PatchApiV1SsoimageIdStatus500,
} from "../../types/SSOImageController/PatchApiV1SsoimageIdStatus.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1SsoimageIdStatus } from "../../clients/SSOImageController/patchApiV1SsoimageIdStatus.ts";

export const patchApiV1SsoimageIdStatusMutationKey = () =>
  [{ url: "/api/v1/ssoimage/:id/status" }] as const;

export type PatchApiV1SsoimageIdStatusMutationKey = ReturnType<
  typeof patchApiV1SsoimageIdStatusMutationKey
>;

export function patchApiV1SsoimageIdStatusMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchApiV1SsoimageIdStatusMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = patchApiV1SsoimageIdStatusMutationKey();
  return mutationOptions<
    PatchApiV1SsoimageIdStatusMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1SsoimageIdStatus400
      | PatchApiV1SsoimageIdStatus401
      | PatchApiV1SsoimageIdStatus500
    >,
    {
      id: PatchApiV1SsoimageIdStatusPathParams["id"];
      data: PatchApiV1SsoimageIdStatusMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return patchApiV1SsoimageIdStatus(id, data, config);
    },
  });
}

/**
 * @description Atualiza o ESSOImageStatus de uma SSOImage pelo Id. **(Requer Authorization para autenticação)**
 * @summary Atualizar status de imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id/status}
 */
export function usePatchApiV1SsoimageIdStatus<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1SsoimageIdStatusMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1SsoimageIdStatus400
        | PatchApiV1SsoimageIdStatus401
        | PatchApiV1SsoimageIdStatus500
      >,
      {
        id: PatchApiV1SsoimageIdStatusPathParams["id"];
        data: PatchApiV1SsoimageIdStatusMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PatchApiV1SsoimageIdStatusMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? patchApiV1SsoimageIdStatusMutationKey();

  const baseOptions = patchApiV1SsoimageIdStatusMutationOptions(
    config,
  ) as UseMutationOptions<
    PatchApiV1SsoimageIdStatusMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1SsoimageIdStatus400
      | PatchApiV1SsoimageIdStatus401
      | PatchApiV1SsoimageIdStatus500
    >,
    {
      id: PatchApiV1SsoimageIdStatusPathParams["id"];
      data: PatchApiV1SsoimageIdStatusMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PatchApiV1SsoimageIdStatusMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1SsoimageIdStatus400
      | PatchApiV1SsoimageIdStatus401
      | PatchApiV1SsoimageIdStatus500
    >,
    {
      id: PatchApiV1SsoimageIdStatusPathParams["id"];
      data: PatchApiV1SsoimageIdStatusMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1SsoimageIdStatusMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1SsoimageIdStatus400
      | PatchApiV1SsoimageIdStatus401
      | PatchApiV1SsoimageIdStatus500
    >,
    {
      id: PatchApiV1SsoimageIdStatusPathParams["id"];
      data: PatchApiV1SsoimageIdStatusMutationRequest;
    },
    TContext
  >;
}
